import React from "react";
import {
  Table, TableHead, TableRow, TableCell, TableBody, Button
} from "@mui/material";
import { Construct_code_category } from "../Constants";

const fixedColumnOrder = ["COURSE_DESCRIPTION", "USER_NAME", ...Construct_code_category.map(c => c.code)];
const codeToLabel = Construct_code_category.reduce((acc, item) => {
  acc[item.code] = item.construct;
  return acc;
}, {});

const DownloadableTable = ({ data }) => {
  const downloadCSV = () => {
    const headers = Object.keys(data[0]);
    const csvContent = [
      headers.join(","),
      ...data.map(row => headers.map(h => row[h]).join(","))
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "data_preview.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div>
      <Button variant="contained" onClick={downloadCSV} style={{ marginBottom: "1rem" }}>
        Download CSV
      </Button>
      <Table>
        <TableHead>
            <TableRow>
                {fixedColumnOrder.map((key) => (
                <TableCell key={key}>
                    {codeToLabel[key] || key}
                </TableCell>
                ))}
            </TableRow>
        </TableHead>


        <TableBody>
            {data.map((row, i) => (
                <TableRow key={i}>
                {fixedColumnOrder.map((key) => (
                    <TableCell key={key}>
                    {row[key] != null && row[key] !== "" ? row[key] : "NA"}
                    </TableCell>
                ))}
                </TableRow>
            ))}
        </TableBody>


      </Table>
    </div>
  );
};

export default DownloadableTable;
